<template>
  <!-- 添加物模型 -->
  <div class="">
    <v-dialog
      class="popbox"
      name="dialog2"
      v-model="isShow"
      title="导入物模型"
      close-on-click-modal
      :modal="true"
      :width="1000"
      @open="open"
      @after-close="handleAfterClose"
      @confirm="handleConfirm"
      append-to-body
    >
      <div class="model-content">
        <p>请导入物模型TSL完整版JSON数据</p>
        <div class="json-content">
          <div contenteditable :class="`input-json ${isError ? 'is-error' : ''}`" @keyup="handleChange"></div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    showInputDialog: {
      type: Boolean,
      default: false,
    },
    productKey: {},
    productId: {},
  },
  data() {
    return {
      jsonStr: {},
      isShow: false,
      isError: false,
    };
  },
  created() {},
  watch: {
    showInputDialog(newVal) {
      this.isShow = newVal;
    },
  },
  methods: {
    open() {},
    handleChange(e) {
      try {
        const get = (str) => str;
        console.log(get);//不要删除
        const _jsonStr = e.target.innerText;
        const json = eval("get(" + _jsonStr + ")");
        if (typeof json === "object") {
          this.jsonStr = json;
          this.isError = false;
        } else {
          throw "Invalid JSON";
        }
      } catch (error) {
        this.$message.error("请输入json格式的数据");
        this.isError = true;
      }
    },
    handleConfirm() {
      if (this.isError) {
        this.$message.error("输入的json内容有误，请检查");
        return;
      }
      let submitData = {
        ...this.jsonStr,
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
      };

      this.$post("/td/td-iot-api/iot/thing/draft/export/v1", submitData, false).then((res) => {
        let code = +res.code;
        if (code === 0) {
          this.$emit("getData");
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
      this.$emit("update:showInputDialog", false);
      Object.assign(this.$data, this.$options.data());
    },
    handleAfterClose() {
      this.$emit("update:showInputDialog", false);
      Object.assign(this.$data, this.$options.data());
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.json-content {
  display: flex;
  align-items: flex-start;
  margin-top: 16px;
  height: 440px;
  .input-json {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 100%;
    outline: none;
    padding: 16px;
    overflow: auto;
    &.is-error {
      border-color: #f00;
    }
  }
}
</style>
